import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceXXL,
  space3XL,
  scale000,
  spaceXL,
  spaceL,
  spaceS,
} from '@xing-com/tokens';
import { Hero, BodyCopy } from '@xing-com/typography';

const StyledHero = styled(Hero)`
  margin: ${spaceXXL} ${scale000} ${spaceXL};

  @media ${mediaConfined} {
    margin: ${space3XL} ${scale000} ${spaceXXL};
  }
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

const StyledTextButton = styled(TextButton)`
  margin-top: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const Styled = {
  Hero: StyledHero,
  BodyCopy: StyledBodyCopy,
  TextButton: StyledTextButton,
};
